module.exports = __webpack_public_path__ + "img/root-canal-treatment.21473b10.jpg";